import { useState } from "react";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { useLawsuitRites } from "../../hooks/useLawsuitRites";
import { Controller, useFormContext } from "react-hook-form";

export default function SelectLawsuitRites({ register, selected }) {
  const { lawsuitRites, isLoading, isError } = useLawsuitRites();
  const methods = useFormContext();

  if (selected) {
    return (
      <>
        {isLoading ? (
          <div>
            <FloatingLabel controlId="floatingInput" label="Rito">
              <Form.Select
                className="form-select form-control"
                name="lawsuit_rite"
                {...methods?.register("lawsuit_rite")}
                aria-label="Rito"
                required
              >
                <option>Carregando... </option>
              </Form.Select>
            </FloatingLabel>
          </div>
        ) : methods ? (
          <div>
            <FloatingLabel controlId="floatingInput" label="Rito">
              <Form.Select
                className="form-select form-control"
                aria-label="Rito"
                {...methods.register("lawsuit_rite")}
                defaultValue={selected}
              >
                <option value="">Selecione ...</option>
                {lawsuitRites?.map((lawsuitRites) => (
                  <option key={lawsuitRites.id} value={lawsuitRites.id}>
                    {lawsuitRites.title}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </div>
        ) : (
          ""
        )}
      </>
    );
  } else {
    return (
      <>
        {isLoading ? (
          <div>
            <FloatingLabel controlId="floatingInput" label="Rito">
              <Form.Select
                className="form-select form-control"
                name="lawsuit_status"
                {...register("lawsuit_rite")}
                aria-label="Rito"
                required
              >
                <option>Carregando... </option>
              </Form.Select>
            </FloatingLabel>
          </div>
        ) : (
          <div>
            <FloatingLabel controlId="floatingInput" label="Rito">
              <Form.Select
                className="form-select form-control"
                aria-label="Rito"
                {...register("lawsuit_rite")}
              >
                <option value="">Selecione ...</option>
                {lawsuitRites?.map((lawsuitRites) => (
                  <option key={lawsuitRites.id} value={lawsuitRites.id}>
                    {lawsuitRites.title}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </div>
        )}
      </>
    );
  }
}
